module.exports = __webpack_public_path__ + "static/006-22fbd70f3897fb37b2388a83603293a9.png";